const initialState = {
    anchor: 'left',
    versaoSistema: [],
    open: false,
    id: '',
    codigo: '',
    sistema: '',
    data_cadastro: '',
    usuario_cadastro: '',
    data_exclusao: '',
    usuario_exclusao: ''
};

export function versaoSistema(state = initialState, action) {
    switch (action.type) {
        case 'FETCHED_ALL_VERSAO_SISTEMA':
            return {
                ...state,
                versaoSistema: action.versaoSistema
            };
        case 'VERSAO_SISTEMA_DETAIL':
            return {
                ...state,
                id: action.id,
                versaoSistema: action.versaoSistema,
                codigo: action.codigo,
                sistema: action.sistema,
                data_cadastro: action.data_cadastro,
                usuario_cadastro: action.usuario_cadastro,
                data_exclusao: action.data_exclusao,
                usuario_exclusao: action.usuario_exclusao
            };
        case 'VERSAO_SISTEMA_CLEAR':
            return {
                ...state,
                anchor: 'left',
                versaoSistema: [],
                open: false,
                id: '',
                codigo: '',
                data_cadastro: '',
                usuario_cadastro: '',
                data_exclusao: '',
                usuario_exclusao: '',
                sistema: ''
            };
        case "VERSAO_SISTEMA_UPDATED":
            return state;
        case "HANDLE_ON_CHANGE":
            return {
                ...state,
                [action.props]: action.value
            };
        default:
            return state
    }
}
